// import React, { useRef, useState, useEffect } from "react";
// import HeadingText from "../../common/HeadingText";
// import { assets } from "../../../Assets/assets";
// import StarRating from "../../common/StarRating";

// const Testimonials = () => {
//   const testimonialData = [
//     {
//       id: 1,
//       image: assets.profile1,
//       rating: 5,
//       review: "“This platform made property investing so much easier. I found two great rentals in just a few months, and both are already performing better than expected.”",
//       name: "Liam Anderson",
//       position: "CEO Digital Avitex",
//     },
//     {
//       id: 2,
//       image: assets.profile2,
//       rating: 4,
//       review: "“As a first-time buyer, I felt guided every step of the way. Found my dream home fast and the support team was always there to answer my questions.”",
//       name: "Adam Will",
//       position: "CEO Agency Avitex",
//     },
//     {
//       id: 3,
//       image: assets.profile3,
//       rating: 5,
//       review: "“The investment opportunities presented here are exceptional. I've seen a 15% return on my first property within just six months of purchase.”",
//       name: "Sarah Johnson",
//       position: "Real Estate Investor",
//     },
//     {
//       id: 4,
//       image: assets.profile4,
//       rating: 5,
//       review: "“Outstanding service and attention to detail. The team helped me navigate complex paperwork and made the entire process seamless and stress-free.”",
//       name: "Maria Garcia",
//       position: "Property Manager",
//     },
//   ];

//   const scrollRef = useRef(null);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [isAutoPlaying, setIsAutoPlaying] = useState(true);

//   // Calculate card width based on screen size
//   const getCardWidth = () => {
//     if (typeof window === 'undefined') return 0;
//     return window.innerWidth >= 768 ? 48 : 85; // percentage
//   };

//   const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

//   const scrollToIndex = (index) => {
//     const scrollContainer = scrollRef.current;
//     if (!scrollContainer) return;

//     const containerWidth = scrollContainer.clientWidth;
//     const cardWidth = (containerWidth * getCardWidth()) / 100;
//     const gap = 40; // 2.5rem gap
//     const targetLeft = index * (cardWidth + gap);

//     const maxScrollLeft = scrollContainer.scrollWidth - containerWidth;
//     scrollContainer.scrollTo({
//       left: clamp(targetLeft, 0, Math.max(0, maxScrollLeft)),
//       behavior: "smooth",
//     });
//   };

//   const handleDotClick = (index) => {
//     setActiveIndex(index);
//     scrollToIndex(index);
//     setIsAutoPlaying(false); // Pause auto-play on user interaction
//   };

//   const handleNext = () => {
//     const nextIndex = (activeIndex + 1) % testimonialData.length;
//     handleDotClick(nextIndex);
//   };

//   const handlePrev = () => {
//     const prevIndex = (activeIndex - 1 + testimonialData.length) % testimonialData.length;
//     handleDotClick(prevIndex);
//   };

//   // Auto-play functionality
//   useEffect(() => {
//     if (!isAutoPlaying) return;

//     const interval = setInterval(() => {
//       handleNext();
//     }, 4000);

//     return () => clearInterval(interval);
//   }, [activeIndex, isAutoPlaying]);

//   // Scroll detection for active index
//   useEffect(() => {
//     const scrollContainer = scrollRef.current;
//     if (!scrollContainer) return;

//     let ticking = false;
//     const onScroll = () => {
//       if (ticking) return;
//       ticking = true;

//       requestAnimationFrame(() => {
//         const scrollLeft = scrollContainer.scrollLeft;
//         const containerWidth = scrollContainer.clientWidth;
//         const cardWidth = (containerWidth * getCardWidth()) / 100;
//         const gap = 40;

//         const newIndex = Math.round(scrollLeft / (cardWidth + gap));
//         setActiveIndex(clamp(newIndex, 0, testimonialData.length - 1));
//         ticking = false;
//       });
//     };

//     scrollContainer.addEventListener("scroll", onScroll, { passive: true });
//     window.addEventListener("resize", onScroll);

//     return () => {
//       scrollContainer.removeEventListener("scroll", onScroll);
//       window.removeEventListener("resize", onScroll);
//     };
//   }, [testimonialData.length]);

//   // Keyboard navigation
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === 'ArrowLeft') {
//         handlePrev();
//       } else if (e.key === 'ArrowRight') {
//         handleNext();
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [activeIndex]);

//   return (
//     <section className="bg-white py-8">
//       <div className="container mx-auto px-6 xl:px-20">
//         <HeadingText
//           label="Our Testimonials"
//           heading="What Our Clients Say"
//           position="center"
//         />

//         <div className="relative mt-8">
//           {/* Navigation Arrows */}
//           <button
//             onClick={handlePrev}
//             className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-8 z-10 bg-white border border-gray-200 rounded-full w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:border-[#E4E95B] group"
//             aria-label="Previous testimonial"
//           >
//             <svg className="w-5 h-5 lg:w-6 lg:h-6 text-gray-600 group-hover:text-[#E4E95B] transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//             </svg>
//           </button>

//           <button
//             onClick={handleNext}
//             className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-8 z-10 bg-white border border-gray-200 rounded-full w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:border-[#E4E95B] group"
//             aria-label="Next testimonial"
//           >
//             <svg className="w-5 h-5 lg:w-6 lg:h-6 text-gray-600 group-hover:text-[#E4E95B] transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//             </svg>
//           </button>

//           {/* Testimonials Container */}
//           <div
//             ref={scrollRef}
//             className="flex gap-10 overflow-x-auto py-4 scroll-smooth snap-x snap-mandatory no-scrollbar"
//             onMouseEnter={() => setIsAutoPlaying(false)}
//             onMouseLeave={() => setIsAutoPlaying(true)}
//             onFocus={() => setIsAutoPlaying(false)}
//             onBlur={() => setIsAutoPlaying(true)}
//           >
//             {testimonialData.map((item, index) => (
//               <div
//                 key={item.id}
//                 className={`bg-[#F8F7F3] rounded-2xl p-8 lg:p-10 flex flex-col justify-between transition-all duration-500 flex-shrink-0 w-[85%] md:w-[48%] snap-start border-2 ${
//                   activeIndex === index
//                     ? "border-[#E4E95B] scale-105"
//                     : "border-transparent "
//                 }`}
//               >
//                 <div className="flex items-center gap-2 mb-6">
//                   <StarRating rating={item.rating} />
//                   <span className="text-sm text-gray-600 ml-2">
//                     ({item.rating}.0)
//                   </span>
//                 </div>

//                 <blockquote className="text-lg leading-relaxed text-gray-700 mb-8 flex-grow">
//                   {item.review}
//                 </blockquote>

//                 <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
//                   <img
//                     src={item.image}
//                     alt={item.name}
//                     className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-md"
//                     loading="lazy"
//                   />
//                   <div className="flex-1 min-w-0">
//                     <h4 className="font-semibold text-gray-900 truncate hover:text-[#E4E95B] transition-colors duration-300">
//                       {item.name}
//                     </h4>
//                     <p className="text-sm text-gray-600 truncate">{item.position}</p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Dots Indicator */}
//           <div className="flex justify-center items-center mt-12 space-x-3">
//             {testimonialData.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => handleDotClick(index)}
//                 className={`rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#E4E95B] focus:ring-offset-2 ${
//                   activeIndex === index
//                     ? "w-8 bg-[#E4E95B] scale-110"
//                     : "w-2.5 h-2.5 bg-gray-300 hover:bg-gray-400"
//                 }`}
//                 aria-label={`Go to testimonial ${index + 1}`}
//                 aria-current={activeIndex === index ? "true" : "false"}
//               />
//             ))}
//           </div>

//           {/* Progress Bar */}
//           <div className="mt-6 flex justify-center">
//             <div className="w-32 h-1 bg-gray-200 rounded-full overflow-hidden">
//               <div
//                 className="h-full bg-[#E4E95B] transition-all duration-1000 ease-out"
//                 style={{
//                   width: `${((activeIndex + 1) / testimonialData.length) * 100}%`
//                 }}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Auto-play Toggle */}
//         <div className="flex justify-center mt-8">
//           <button
//             onClick={() => setIsAutoPlaying(!isAutoPlaying)}
//             className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800 transition-colors"
//             aria-label={isAutoPlaying ? "Pause auto-play" : "Start auto-play"}
//           >
//             <div className={`w-3 h-3 rounded-full border-2 ${isAutoPlaying ? "bg-[#E4E95B] border-[#E4E95B]" : "border-gray-400"}`} />
//             {isAutoPlaying ? "Auto-playing" : "Click to play"}
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;

import React, { useRef, useState, useEffect } from "react";
import HeadingText from "../../common/HeadingText";
import { assets } from "../../../Assets/assets";
import StarRating from "../../common/StarRating";

const Testimonials = () => {
  const testimonialData = [
    {
      image: assets.profile1,
      rating: 5,
      review:
        "“This platform made property investing so much easier. I found two great rentals in just a few months, and both are already performing better than expected.”",
      name: "Liam Anderson",
      position: "CEO Digital Avitex",
    },
    {
      image: assets.profile2,
      rating: 4,
      review:
        "“As a first-time buyer, I felt guided every step of the way. Found my dream home fast and the support team was always there to answer my questions.”",
      name: "Adam Will",
      position: "CEO Agency Avitex",
    },
    {
      image: assets.profile3,
      rating: 5,
      review:
        "“This platform made property investing so much easier. I found two great rentals in just a few months, and both are already performing better than expected.”",
      name: "Liam Anderson",
      position: "CEO Digital Avitex",
    },
    {
      image: assets.profile4,
      rating: 5,
      review:
        "“As a first-time buyer, I felt guided every step of the way. Found my dream home fast and the support team was always there to answer my questions.”",
      name: "Adam Will",
      position: "CEO Agency Avitex",
    },
  ];

  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const autoScrollInterval = useRef(null);

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  const scrollToIndex = (index) => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const card = scrollContainer.children[index];
    if (!card) return;

    const containerWidth = scrollContainer.clientWidth;
    const cardWidth = card.offsetWidth;
    const targetLeft = card.offsetLeft - (containerWidth - cardWidth) / 2;
    const maxScrollLeft = scrollContainer.scrollWidth - containerWidth;

    scrollContainer.scrollTo({
      left: clamp(targetLeft, 0, Math.max(0, maxScrollLeft)),
      behavior: "smooth",
    });
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
    scrollToIndex(index);
    setIsPaused(true);
    setTimeout(() => setIsPaused(false), 5000);
  };

  useEffect(() => {
    if (isPaused) return;

    autoScrollInterval.current = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % testimonialData.length;
        scrollToIndex(nextIndex);
        return nextIndex;
      });
    }, 3000);

    return () => {
      if (autoScrollInterval.current) {
        clearInterval(autoScrollInterval.current);
      }
    };
  }, [isPaused, testimonialData.length]);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const scrollLeft = scrollContainer.scrollLeft;
        const containerCenter = scrollLeft + scrollContainer.clientWidth / 2;

        let closestIndex = 0;
        let minDist = Infinity;
        Array.from(scrollContainer.children).forEach((card, idx) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const dist = Math.abs(containerCenter - cardCenter);
          if (dist < minDist) {
            minDist = dist;
            closestIndex = idx;
          }
        });

        setActiveIndex(closestIndex);
        ticking = false;
      });
    };

    onScroll();

    scrollContainer.addEventListener("scroll", onScroll, { passive: true });

    const handleResize = () => onScroll();
    window.addEventListener("resize", handleResize);

    return () => {
      scrollContainer.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="bg-white py-8">
      <div className="container mx-auto px-6 xl:px-20 text-center">
        <HeadingText
          label="Our Testimonials"
          heading="What's People Say's"
          position="center"
        />

        <div
          ref={scrollRef}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          className="md:mt-10 mt-5 flex gap-10 overflow-x-auto py-1 scroll-smooth snap-x snap-mandatory no-scrollbar"
        >
          {testimonialData.map((item, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#F8F7F3] flex-shrink-0 to-[#FEFDFB] shadow-lg rounded-2xl text-left p-8 flex flex-col justify-between hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 w-full lg:w-[48%] snap-start border border-gray-100"
            >
              <div>
                <div className="flex items-center gap-1 text-[#000] mb-4">
                  <StarRating rating={item.rating} />
                </div>

                <p className="leading-relaxed text-gray-700 mb-6 italic text-lg">
                  {item.review}
                </p>
              </div>

              <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-14 h-14 rounded-full object-cover ring-2 ring-gray-200"
                />
                <div>
                  <h4 className="font-semibold text-lg text-primaryTextColor hover:text-[#E4E95B] transition-colors duration-300">
                    {item.name}
                  </h4>
                  <p className="text-sm text-gray-500">{item.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center items-center mt-8 space-x-2">
          {testimonialData.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`w-2.5 h-2.5 ${
                index === testimonialData.length - 1 && "hidden"
              } rounded-full transition-all duration-300 ${
                activeIndex === index ? "bg-black scale-110" : "bg-gray-400"
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
